import { httpClient } from '@/core/api/http-client'
import type { PriceType, PriceTypeInput } from '@/domain/entities/price-type.entity'
import type { PriceTypeRepository } from '@/domain/repositories/price-type.repository'
import { unwrap, unwrapList } from '@/infrastructure/shared/unwrap'
import type { PriceTypeDto } from './price-type.dto'
import { priceTypeMapper } from './price-type.mapper'

export class PriceTypeHttpRepository implements PriceTypeRepository {
  async list(): Promise<PriceType[]> {
    const raw = await httpClient.get<unknown>('/price-types')
    return unwrapList<PriceTypeDto>(raw).map(priceTypeMapper.toPriceType)
  }

  async getById(id: string): Promise<PriceType> {
    const raw = await httpClient.get<unknown>(`/price-types/${id}`)
    return priceTypeMapper.toPriceType(unwrap<PriceTypeDto>(raw))
  }

  async create(input: PriceTypeInput): Promise<PriceType> {
    const raw = await httpClient.post<unknown>('/price-types', {
      name: input.name,
    })
    return priceTypeMapper.toPriceType(unwrap<PriceTypeDto>(raw))
  }

  async update(id: string, input: PriceTypeInput): Promise<PriceType> {
    const raw = await httpClient.put<unknown>(`/price-types/${id}`, {
      name: input.name,
    })
    return priceTypeMapper.toPriceType(unwrap<PriceTypeDto>(raw))
  }

  async remove(id: string): Promise<void> {
    await httpClient.delete(`/price-types/${id}`)
  }
}
